import {
	clearHereNowReducer,
	getPlayingUsersSuccess
} from "modules/actions";
import { createReducer } from "redux-act";


export interface IHereNowUsers {
	occupants: number
}

const defaultState = {
	occupants: 0,
};

export const here_now_users = createReducer<IHereNowUsers>( {}, defaultState )

	.on( clearHereNowReducer, ( state ) => ({
		...state,
		...defaultState,
		occupants: state.occupants
	}) )

	.on(getPlayingUsersSuccess, (state, payload) => ({
		...state,
		occupants: payload
	}))
;
